import "./fonts.css";
import { createTheme } from "@mui/material/styles";

const TypographyTheme = createTheme({
  typography: {
    h1: {
      fontFamily: "Open Sans Condensed Bold, sans-serif",
      fontSize: "17px", //"15px", //"19px",
      "@media (max-width:600px)": {
        fontSize: "17px", //"14px", //"12px",
      },
      color: "#345F70",
      fontWeight: "300",
      lineHeight: "1.16",
    },
    h2: {
      fontFamily: "Open Sans Condensed Bold, sans-serif",
      fontSize: "14px", //"12px", //"16px",
      "@media (max-width:600px)": {
        fontSize: "14px", //"12px",
      },
      color: "#345F70",
      fontWeight: "300",
      lineHeight: "1.16",
    },
    h3: {
      fontFamily: "Open Sans Condensed Bold, sans-serif",
      fontSize: "14px", //"12px", //"16px",
      "@media (max-width:600px)": {
        fontSize: "14px", //"12px",
      },
      color: "#4D4D4D",
      fontWeight: "300",
      lineHeight: "1.16",
    },
    h4: {
      fontFamily: "Open Sans Condensed Bold, sans-serif",
      fontSize: "13px", //"12px", //"15px",
      "@media (max-width:600px)": {
        fontSize: "13px", //"12px",
      },
      color: "#4D4D4D",
      fontWeight: "300",
      lineHeight: "1.16",
    },
    h5: {
      fontFamily: "Open Sans, sans-serif",
      fontSize: "15px", //"19px",
      "@media (max-width:600px)": {
        fontSize: "12px",
      },
      fontWeight: "400",
      lineHeight: "1.16",
    },
    h6: {
      fontFamily: "Open Sans Condensed Light, sans-serif",
      fontSize: "14px", //"13px", //"16px",
      "@media (max-width:600px)": {
        fontSize: "14px", //"12px",
      },
      color: "#4D4D4D",
      fontWeight: "300",
      lineHeight: "1.16",
    },
    outlined: {
      fontFamily: "Open Sans Condensed Light, sans-serif",
      fontSize: "14px", //"13px", //"16px",
      "@media (max-width:600px)": {
        fontSize: "14px", //"12px",
      },
      color: "#4D4D4D",
      fontWeight: "300",
      lineHeight: "1.16",
    },
    body1: {
      fontFamily: "Open Sans Condensed Light, sans-serif",
      fontSize: "14px", //"12px", //"15px",
      "@media (max-width:600px)": {
        fontSize: "14px", //"12px",
      },
      color: "#4D4D4D",
      fontWeight: "300",
      lineHeight: "1.16",
    },
    body2: {
      fontFamily: "Open Sans Condensed Light, sans-serif",
      fontSize: "11px", //"10px", //"13px",
      "@media (max-width:600px)": {
        fontSize: "11px", //"10px",
      },
      color: "#4D4D4D",
      fontWeight: "300",
      lineHeight: "1.16",
    },
  },
});

export default TypographyTheme;
